import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import slideLogin from '../img/slide-login.jpeg';
import logoDR from "../img/logo-dataregion.png";

export default function ModernLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const nav = useNavigate();

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
    setErrors({ ...errors, [field]: "" });
    setApiError("");
  };

  const submit = async (e) => {
    e.preventDefault();

    // Validación
    let newErrors = {};
    if (!form.email.trim()) newErrors.email = "El correo es obligatorio.";
    if (!form.password.trim())
      newErrors.password = "La contraseña es obligatoria.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // MISMA LÓGICA DE API QUE YA FUNCIONA
    try {
      const res = await axios.post("https://back.dataregion.com.co/api/auth/login", form);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      nav("/dashboard");
    } catch (err) {
      setApiError(err.response?.data?.message || "Error en el inicio de sesión");
    }
  };

  return (
    <div className="login-container">
      {/* COLUMNA IZQUIERDA */}
      <div
  className="login-left"
  style={{
    backgroundImage: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${slideLogin})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="login-left-content">
    <p className="login-left-text">
      Ciénaga San Silvestre, Barrancabermeja.
    </p>
  </div>
</div>

      {/* COLUMNA DERECHA */}
      <div className="login-right">
        <div className="login-form-box">
          <img src={logoDR} alt="DataRegión" className="login-logo-top" />
          <h2 className="login-title">Acceder</h2>
          <p className="subtitle">Inicia sesión con tu correo y contraseña.</p>

          {apiError && <div className="api-error">{apiError}</div>}

          <form onSubmit={submit} className="login-form">
            <div className="input-group">
              <label>Correo Electrónico</label>
              <input
                type="email"
                className={errors.email ? "error-input" : ""}
                placeholder="example@email.com"
                value={form.email}
                onChange={(e) => handleChange("email", e.target.value)}
              />
              {errors.email && <p className="error-text">{errors.email}</p>}
            </div>

            <div className="input-group">
              <label>Contraseña</label>
              <input
                type="password"
                className={errors.password ? "error-input" : ""}
                placeholder="********"
                value={form.password}
                onChange={(e) => handleChange("password", e.target.value)}
              />
              {errors.password && (
                <p className="error-text">{errors.password}</p>
              )}
            </div>

            <button className="login-btn" type="submit">
              Iniciar sesión
            </button>

            <div className="register-link">
              ¿No tienes cuenta?
              <Link to="/register"> Regístrate</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
